export const convertTo12HourIfNeeded = (time) => {
    if (!time) return ""; 
    time = time.trim().toUpperCase(); 
    const is12HourFormat = /^(0?[1-9]|1[0-2]):[0-5][0-9]\s?(AM|PM)$/.test(time);
    if (is12HourFormat) {
        return time;   
    } 
    const is24HourFormat = /^([01]\d|2[0-3]):[0-5]\d$/.test(time);
    if (is24HourFormat) {
        let [hours, minutes] = time.split(":").map(Number);
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;
        return `${hours.toString().padStart(2, "0")}:${minutes
            .toString()
            .padStart(2, "0")} ${ampm}`;
    }

    console.warn("Invalid time format:", time);
    return time; 
};

export const convertDateTimeTo12Hour = (input) => {
    if (!input) return "";

    // Match full datetime format: "2025-11-19 20:50:00"
    const match = input.match(/^(\d{4}-\d{2}-\d{2})\s+(\d{2}):(\d{2}):\d{2}$/);

    if (!match) {
        console.warn("Invalid datetime format:", input);
        return input;
    }

    const date = match[1];         // "2025-11-19"
    let hours = Number(match[2]);  // 20
    const minutes = match[3];      // "50"

    // Convert hours
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    const formattedTime =
        `${hours.toString().padStart(2, "0")}:${minutes} ${ampm}`;

    return `${date} ${formattedTime}`;
};
